import React from 'react';
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import moment from 'moment';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';

const InboxList = ({
  showInbox,
  selectedEmail,
  showNewMail,
  mailData,
  setSelectedEmail,
  setShowNewMail,
  pageNumber,
  pageSize,
  setPageNumber
}) => {
  if (!showInbox) return null;

  const formatDate = (timestamp) => {
    return moment(timestamp).format("ddd HH:mm");
  };

  return (
    <Grid item xs={12} sm={12} md={selectedEmail || showNewMail ? 3 : 10}>
      <Paper>
        <Typography variant="h6" style={{ backgroundColor: '#D3D3D3', paddingLeft: '6px' }}>
          Inbox
        </Typography>

        {mailData?.data?.getStudySiteEmails?.length > 0 ? (
          mailData.data.getStudySiteEmails.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                setSelectedEmail(item);
                setShowNewMail(false);
              }}
              style={{
                padding: '8px',
                borderBottom: '2px solid #e0e0e0',
                cursor: 'pointer',
                backgroundColor: selectedEmail === item ? '#f0f0f0' : 'white'
              }}
            >
              <div style={{ display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  <Typography variant="body2" style={{ fontWeight: 500 }}>{item.fromUser?.email}</Typography>
                  <Typography variant="body2">{item.emailSubject}</Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'vertical'
                    }}
                    dangerouslySetInnerHTML={{ __html: item.emailBody }}
                  />
                </div>
                <div style={{ marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                  <Typography variant="body2">{formatDate(item.timeStamp)}</Typography>
                </div>
              </div>
            </div>
          ))
        ) : (
          <Typography style={{ padding: '8px', textAlign: 'center' }} color="textSecondary">No emails found.</Typography>
        )}

        {mailData?.data?.getStudySiteEmails?.length>0 && <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}> 
          {pageNumber > 1 && (
            <div
              className='inboxpagination'
              onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
            >
              <FirstPageIcon />
            </div>
          )}
          <Typography variant="body2" style={{ alignSelf: 'center' }}>
            Page {pageNumber}
          </Typography>
          {mailData.data.getStudySiteEmails.length === pageSize && (
            <div
 className='inboxpagination'
             onClick={() => setPageNumber(prev => prev + 1)}
            >
              <LastPageIcon />
            </div>
          )}
        </div>}
      </Paper>
    </Grid>
  );
};

export default InboxList;
